import React, { useState } from "react";
import AddButton from "./AddButton";

const AddButtonExample: React.FC = () => {
	const [count, setCount] = useState(0);

	return (
		<div className="space-y-8 p-6">
			<div>
				<h3 className="text-lg font-semibold mb-4">AddButton Component Examples</h3>

				<div className="space-y-6">
					{/* Default */}
					<div>
						<h4 className="text-md font-medium mb-2">Default</h4>
						<AddButton label="Lägg till tagg" onClick={() => setCount((c) => c + 1)} />
						<p className="text-sm text-gray-600 mt-2">Clicked {count} times</p>
					</div>

					{/* Alternate label */}
					<div>
						<h4 className="text-md font-medium mb-2">Alternate label</h4>
						<AddButton label="Skapa ny koncern" onClick={() => {}} />
					</div>

					{/* Disabled */}
					<div>
						<h4 className="text-md font-medium mb-2">Disabled</h4>
						<AddButton label="Lägg till tagg" disabled onClick={() => {}} />
					</div>

					{/* Next to another control (typical layout) */}
					<div>
						<h4 className="text-md font-medium mb-2">Beside a field</h4>
						<div className="flex items-center gap-3">
							<div className="h-[2.3125rem] flex-1 rounded-md border border-gray-300 bg-gray-50" />
							<AddButton label="Skapa ny koncern" onClick={() => {}} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddButtonExample;
